import { render, staticRenderFns } from "./PrintPdv.vue?vue&type=template&id=18efc27a&"
import script from "./PrintPdv.vue?vue&type=script&lang=js&"
export * from "./PrintPdv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports